import { render, staticRenderFns } from "./TotalMentions.vue?vue&type=template&id=01088d29"
import script from "./TotalMentions.vue?vue&type=script&lang=js"
export * from "./TotalMentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports